export const slotGameInfoTextContent = {
  paragraphText: (
    <>
      Shadow of sabbah <br />
      Unearth hidden treasures in Mining Rush. <br />
      Set deep underground, the 7×7 grid offers a host of lavish symbols, with
      five or more landing in a cluster awarding impressive wins. <br />
      Any winning combination featuring a dynamite-themed Scatter in the base
      game sees the Scatter turn into a mine, which remains stuck on the reels
      for the remainder of the round, strengthening the chance of hitting
      additional wins. <br />
      Mines accumulate progressive points, receiving one point for each win
      generated. When three points are collected the mines progress to the next
      level, guaranteeing further winnings. <br />
    </>
  ),
  listItemTitle: "What to expect:",
  listText: [
    {
      listItem:
        "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
    },
    {
      listItem:
        "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
    },
    {
      listItem:
        "For every new mine created in free spins, a further two spins are awarded.",
    },
  ],
  gameDetailsList: [
    { label: "Release Date", value: "10/12/2024" },
    { label: "Bet Lines", value: "3x3" },
    { label: "Bonus Game", value: "Yes" },
    { label: "Volatility", value: "Medium" },
    {
      label: "Languages", value:
        <div className="flag-box">
          <img src="/assets/stock-img/flag-england.webp" alt="Image" />
          <img src="/assets/stock-img/flag-spain.webp" alt="Image" />
          <img src="/assets/stock-img/flag-france.webp" alt="Image" />
          <img src="/assets/stock-img/flag-italy.webp" alt="Image" />
        </div>
    },
  ],
  headingText: "More Games",
  btnText: "Play",
  imgSrcGame: "/assets/stock-img/game_info_img.webp"
};

export const slotGamesInfoTextContent = {
  '/maya-bonanza': {
    paragraphText: (
      <>
        Step into the world of ancient wonders with Maya Bonanza, a slot game that immerses you in the breathtaking splendor of the Aztec civilization. Amidst lush jungles and towering pyramids, spin the reels to uncover dazzling treasures hidden for centuries. Packed with vibrant visuals, exciting features, and thrilling bonus rounds, this slot captures the mystique of an ancient world brimming with gold and glory. Discover cascading wins, free spins, and multipliers as you unravel the secrets of the Aztec empire. Are you ready to embark on a journey through time to claim the treasures of this legendary civilization?      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "5x3" },
      { label: "Slot type", value: "Pay Line" },
      { label: "Volatility", value: "Medium" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/witch-orb': {
    paragraphText: (
      <>
        Dive into the world of magic and mystery with Witch’s Cauldron, a spellbinding 6x5 slot where mystical potions and enchanting surprises await. Featuring a Pay Anywhere mechanic, 96.5% RTP, and very high volatility, this magical adventure offers thrilling gameplay and the chance to win up to 5000X your bet. Unlock enchanting rewards with features like Double Bet, Free Spins, and Bonus Spins, while the 27% win hit rate keeps the magic alive. With its bewitching theme of Mystic Spells and Potions, every spin immerses you deeper into the cauldron of endless possibilities and rewards. Spin the reels and unleash the magic!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "6x5" },
      { label: "Type Of Slot", value: "Pay anywhere" },
      { label: "Slot Features", value: "Double bet, free spin, bonus spins" },
      { label: "Volatility", value: "Very High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/panda-punch': {
    paragraphText: (
      <>
        Step into the serene bamboo forests and witness the action-packed mastery of martial arts with Panda Punch, a thrilling 6x5 slot adventure. Featuring a Pay Anywhere mechanic, 96.5% RTP, and very high volatility, this game delivers fast-paced excitement with the chance to win up to 5000X your bet. Engage in dynamic battles and unlock features like Double Bet, Free Spins, and Bonus Spins, with a 27% win hit rate to keep the action flowing. With its unique theme of Martial Arts in Bamboo Forests, every spin is a step closer to glory and hidden treasures. Join the martial arts master panda and conquer the reels!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "6x5" },
      { label: "Type Of Slot", value: "Pay anywhere" },
      { label: "Slot Features", value: "Double bet, free spin, bonus spins" },
      { label: "Volatility", value: "Very High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/cosmic-hero': {
    paragraphText: (
      <>
        Embark on an epic journey with Cosmic Heroes, where interstellar champions unite to safeguard the galaxy and deliver out-of-this-world rewards. Set against a backdrop of dazzling nebulae and distant star systems, this action-packed slot invites you to join the ultimate battle for galactic peace. Spin the reels alongside cosmic warriors, unlocking powerful bonuses, free spins, and multipliers as you soar through the cosmos. With every spin, you edge closer to uncovering cosmic jackpots and becoming a legend in the galaxy. Gear up, champion—the stars are calling!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "5x3" },
      { label: "Slot type", value: "Pay Line" },
      { label: "Volatility", value: "Medium" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/viking-sword': {
    paragraphText: (
      <>
        Vikings Sword
        Join the ranks of fearless Norse warriors in Vikings Sword, a legendary 6x5 slot that brings the epic tales of Viking heroism to life. With a Pay Anywhere mechanic, 96.5% RTP, and very high volatility, this slot offers high-stakes excitement and the chance to claim a 5000X max win. Unleash the power of legendary swords with features like Double Bet, Free Spins, and Bonus Spins, while the 27% win hit rate ensures frequent and rewarding gameplay. Immerse yourself in the theme of Norse Warrior Legends, where each spin takes you closer to glory and untold treasures. Sharpen your swords and conquer the reels!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "6x5" },
      { label: "Type Of Slot", value: "Pay anywhere" },
      { label: "Slot Features", value: "Double bet, free spin, bonus spins" },
      { label: "Volatility", value: "Very High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/road-of-anubis': {
    paragraphText: (
      <>
        Embark on a mystical journey through the sands of ancient Egypt with Road of Anubis, a captivating 6x5 slot where the secrets of the afterlife await. With a Pay Anywhere mechanic, 96.5% RTP, and very high volatility, this slot promises an unforgettable adventure with the potential to win up to 5000X your bet. Discover treasures guarded by the god of the afterlife with features like Double Bet, Free Spins, and Bonus Spins, while the 27% win hit rate ensures frequent rewards. Immerse yourself in the theme of Journey Through the Sands of Afterlife and unravel the mysteries of Anubis on your quest for fortune and glory!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "6x5" },
      { label: "Type Of Slot", value: "Pay anywhere" },
      { label: "Slot Features", value: "Double bet, free spin, bonus spins" },
      { label: "Volatility", value: "Very High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/wild-mafia': {
    paragraphText: (
      <>
        Step into the treacherous world of the Wild Mafia, a thrilling 6x5 slot where danger and fortune go hand in hand. With a Pay Anywhere mechanic, 96.5% RTP, and very high volatility, this high-stakes game offers the chance to win up to 5000X your bet. Team up with the wildest mafia crew in town and unlock thrilling features like Double Bet, Free Spins, and Bonus Spins, while the 27% win hit rate keeps the action intense. Immerse yourself in the gritty world of Underworld Adventure, where every spin brings you closer to riches or peril. Ready to strike it big with the mafia?      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "6x5" },
      { label: "Type Of Slot", value: "Pay anywhere" },
      { label: "Slot Features", value: "Double bet, free spin, bonus spins" },
      { label: "Volatility", value: "Very High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/dragon-curse': {
    paragraphText: (
      <>
        Unleash your courage and face the fiery wrath of ancient dragons in Dragon Curse, a thrilling 6x5 slot where treasure and danger await at every turn. With a Pay Anywhere mechanic, 96.5% RTP, and very high volatility, this game offers the chance to win up to 5000X your bet while navigating the curse of the fire beasts. Unlock powerful features like Double Bet, Free Spins, and Bonus Spins, with a 27% win hit rate to keep the action intense. Immerse yourself in the epic Dragon Curse - Fury of the Fire Beasts, where each spin could ignite a fiery fortune or awaken the dragons' fury!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "6x5" },
      { label: "Type Of Slot", value: "Pay anywhere" },
      { label: "Slot Features", value: "Double bet, free spin, bonus spins" },
      { label: "Volatility", value: "Very High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/destroy-monsters': {
    paragraphText: (
      <>
        Prepare for an action-packed battle in Destroy Monsters, a 6x5 grid slots game where you face off against colossal creatures. With a 96.56% RTP, high volatility, and a 16.51% win hit frequency, this thrilling game features Free Spins and Bonus Buy options. Dive into an Epic Creature Showdown and unleash your inner warrior as you fight for massive rewards. Every spin brings you closer to defeating these terrifying monsters and claiming your share of the spoils!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "7x5" },
      { label: "Slot Features", value: "Free spins, Bonus Buy" },
      { label: "Slot Type", value: "Ways win" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/aztec-protectors': {
    paragraphText: (
      <>
        Step into the heart of ancient civilization with Aztec Protectors, a 6x5 grid slots game that invites you to uncover hidden treasures while defending the golden Aztec empire. Boasting a 96.56% RTP, high volatility, and a 16.51% win hit frequency, this game offers exciting features like Free Spins and Bonus Buy. As one of the empire's defenders, you’ll face fierce challenges and uncover massive rewards as you protect the empire's untold riches!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "7x5" },
      { label: "Slot Features", value: "Free spins, Bonus Buy" },
      { label: "Slot Type", value: "Ways win" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/purple-cave': {
    paragraphText: (
      <>
        Embark on a thrilling adventure in Purple Cave, a 6x5 grid slots game that takes you deep into a mysterious cave filled with sparkling gems and hidden treasures. With a 96.56% RTP, high volatility, and a 16.51% win hit frequency, this game offers Free Spins and the option for Bonus Buy. Venture into the dark abyss and uncover precious rewards as you explore the untold secrets of this glittering underworld!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "7x5" },
      { label: "Slot Features", value: "Free spins, Bonus Buy" },
      { label: "Slot Type", value: "Ways win" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/space-wars': {
    paragraphText: (
      <>
        Prepare for an exhilarating cosmic adventure in Spacewars, a 6x5 grid slot game that immerses you in intergalactic battles where you fight for victory among the stars. With a 96.56% RTP, high volatility, and a 16.51% win hit frequency, this game features Free Spins and the Bonus Buy option, offering thrilling chances for big wins. Blast off and navigate the vast galaxy to secure your place among the stars!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "7x5" },
      { label: "Slot Features", value: "Free spins, Bonus Buy" },
      { label: "Slot Type", value: "Ways win" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/pineapple-paradise': {
    paragraphText: (
      <>
        Escape to a tropical haven with Pineapple Paradise, a vibrant 6x5 slot offering an island getaway filled with exciting features and rewards. With a Pay Anywhere mechanic, 96.5% RTP, and very high volatility, this game offers players the chance to win up to 5000X their bet. Step into the golden pineapple’s realm and unlock treasures through features like Double Bet, Free Spins, and Bonus Spins, all while enjoying a 27% win hit rate. Immerse yourself in a Tropical Island Escape, where every spin is a chance to uncover exotic riches and experience the thrill of paradise!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "6x5" },
      { label: "Type Of Slot", value: "Pay anywhere" },
      { label: "Slot Features", value: "Double bet, free spin, bonus spins" },
      { label: "Volatility", value: "Very High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/power-shield': {
    paragraphText: (
      <>
        Step into the Forge of Mighty Heroes and prepare for an epic adventure with Power Shield, the ultimate slot game for brave warriors. Arm yourself with a legendary shield and dive into a world of valor and fortune. Engage in battles for glory as you uncover hidden treasures, unlock heroic features, and embrace the thrill of victory. With stunning visuals, captivating gameplay, and rewards fit for a true champion, Power Shield invites you to forge your destiny and claim your place among the legends.      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "5x3" },
      { label: "Slot type", value: "Pay Line" },
      { label: "Volatility", value: "Medium" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/gates-of-titan': {
    paragraphText: (
      <>
        Enter the awe-inspiring Gates of Titan and step into the majestic Realm of Giants, where adventure and colossal rewards await the fearless. Journey through towering gates into a world ruled by mighty titans, with treasures beyond imagination hidden within. Experience the grandeur of epic landscapes, exhilarating gameplay, and features as immense as the giants themselves. With every spin, uncover secrets of this legendary realm and claim your share of the titanic rewards. Are you ready to face the giants and seize your destiny? The adventure begins now!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "5x3" },
      { label: "Slot type", value: "Pay Line" },
      { label: "Volatility", value: "Medium" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/cyber-box': {
    paragraphText: (
      <>
        Step into the electrifying world of Cyber Box, where the digital grid pulses with neon lights and high-tech excitement. Immerse yourself in a futuristic playground of advanced technology, where every spin unlocks thrilling features and dazzling wins. Navigate the chaos of the digital grid, packed with wild symbols, cascading reels, and bonus rounds that will keep your adrenaline surging. In this realm of cyber mayhem, fortune favors the bold, and every play is a step closer to futuristic riches. Are you ready to light up the grid and claim your digital destiny? The future awaits!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "5x3" },
      { label: "Slot type", value: "Pay Line" },
      { label: "Volatility", value: "Medium" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/diamond-gun': {
    paragraphText: (
      <>
        Gear up for the ultimate heist in Diamond Gun, a thrilling 7x7 cluster slot where you’ll wield a diamond-encrusted weapon to steal sparkling prizes! With a 96.62% RTP, high volatility, and a 29.03% win hit frequency, this action-packed slot offers exciting gameplay with in-game Free Spins and Bonus Spins features. Step into the Heist of the Glittering Vault, where every spin brings you closer to priceless treasures and dazzling rewards. Ready, aim, win!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "7x7" },
      { label: "Slot Features", value: "In-Game free spins, bonus spins" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/gate-of-heaven': {
    paragraphText: (
      <>
        Ascend to the celestial realms in Guardian of Heaven, a divine 6x5 slot where you’ll fight alongside a powerful heavenly guardian for divine rewards. Featuring a Pay Anywhere mechanic, 96.5% RTP, and very high volatility, this game offers a thrilling chance to win up to 5000X your bet while unlocking celestial treasures. Engage in epic battles with features like Double Bet, Free Spins, and Bonus Spins, and enjoy a 27% win hit rate to keep the action flowing. Immerse yourself in the Guardian of Heaven - Celestial Protector’s Quest and seek out heavenly riches with every spin!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "6x5" },
      { label: "Type Of Slot", value: "Pay anywhere" },
      { label: "Slot Features", value: "Double bet, free spin, bonus spins" },
      { label: "Volatility", value: "Very High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/zodiac-rush': {
    paragraphText: (
      <>
        Race through the stars in Zodiac Rush, a captivating 7x7 cluster slot where aligning the zodiac signs unlocks celestial fortunes. With a 96.62% RTP, high volatility, and a 29.03% win hit frequency, this cosmic adventure offers thrilling gameplay, featuring in-game Free Spins and Bonus Spins. Navigate the stars and unlock heavenly rewards as you embark on a Race Through the Cosmic Signs, where each spin brings you closer to your celestial destiny and sparkling wins!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "7x7" },
      { label: "Slot Features", value: "In-Game free spins, bonus spins" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/jelly-boom': {
    paragraphText: (
      <>
        Get ready for a blast of sugary fun in Jelly Boom, a vibrant 7x7 cluster slot where colorful jelly candies explode to deliver sweet, big wins. With a 96.62% RTP, high volatility, and a 29.03% win hit frequency, this explosive game offers thrilling gameplay with in-game Free Spins and Bonus Spins features. Dive into the Sweet Explosive Fun, where every burst of candy brings you closer to delicious rewards and thrilling surprises!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "7x7" },
      { label: "Slot Features", value: "In-Game free spins, bonus spins" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/sweet-rush': {
    paragraphText: (
      <>
        Step into the candy-coated world of Sweet Rush, a delightful 7x7 cluster slot filled with sugary treats and the chance for exciting rewards. With a 96.62% RTP, high volatility, and a 29.03% win hit frequency, this sweet adventure features thrilling gameplay with in-game Free Spins and Bonus Spins. Immerse yourself in Candyland Chaos, where every cluster of candies brings a rush of delightful surprises and the opportunity to win big!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "7x7" },
      { label: "Slot Features", value: "In-Game free spins, bonus spins" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/vampires-lair': {
    paragraphText: (
      <>
        Step into the dark and mysterious world of Vampires Liar, a thrilling 6x5 slot adventure with a Gothic vampire theme. With a Pay Anywhere mechanic, 96.5% RTP, and very high volatility, every spin offers the chance to uncover ancient secrets and untold riches. Features like Double Bet, Free Spins, and Bonus Spins with Multipliers add layers of excitement, while the potential for a 5000X max win keeps players on the edge of their seats. The 27% win hit rate ensures frequent rewards, while haunting visuals and an eerie soundtrack immerse you in the game’s chilling atmosphere. Are you ready to embrace the shadows and claim your fortune?      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "6x5" },
      { label: "Type Of Slot", value: "Pay anywhere" },
      { label: "Slot Features", value: "Double bet, free spin, bonus spins" },
      { label: "Volatility", value: "Very High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/gladiator-colessium': {
    paragraphText: (
      <>
        Prepare for an unforgettable journey back to the Roman Empire with Gladiator Colosseum, a 6x5 slot that brings the thrilling world of gladiators to life. With a Pay Anywhere mechanic, 96.5% RTP, and very high volatility, the game offers a perfect blend of excitement and massive win potential. Unlock epic rewards through features like Double Bet, Free Spins, and Bonus Spins, with the chance to score a 5000X max win. Boasting a 27% win hit rate, this action-packed slot ensures frequent wins while immersing players in the grandeur of a Roman arena. Step into the colosseum, where every spin could lead to glory and fortune!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "6x5" },
      { label: "Type Of Slot", value: "Pay anywhere" },
      { label: "Slot Features", value: "Double bet, free spin, bonus spins" },
      { label: "Volatility", value: "Very High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/splendid-suleyman': {
    paragraphText: (
      <>
        Embark on a journey through the opulent world of the Ottoman Empire with Splendid Suleyman, a majestic 6x5 slot inspired by the legendary Sultan Suleyman. Featuring a Pay Anywhere mechanic, 96.5% RTP, and very high volatility, this slot offers the perfect balance of excitement and rewarding potential. Discover treasures through Double Bet, Free Spins, and Bonus Spins, with the chance to win up to 5000X your bet. The 27% win hit rate ensures engaging gameplay, while the rich visuals and immersive soundtrack transport you to a world of unmatched grandeur. Spin the reels and experience the magnificence of Sultan Suleyman's reign!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "6x5" },
      { label: "Type Of Slot", value: "Pay anywhere" },
      { label: "Slot Features", value: "Double bet, free spin, bonus spins" },
      { label: "Volatility", value: "Very High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/nordic-raiders': {
    paragraphText: (
      <>
        Set sail on a fearless journey across icy terrains with Nordic Raider, a thrilling 6x5 slot inspired by the daring adventures of Viking warriors. With a Pay Anywhere mechanic, 96.5% RTP, and very high volatility, the game offers an exhilarating chance to plunder treasures and win up to 5000X your bet. Features like Double Bet, Free Spins, and Bonus Spins add excitement and depth to your adventure, while a 27% win hit rate keeps the rewards flowing. Immerse yourself in the rugged beauty of the Norse wilderness and channel your inner raider as you conquer the reels for glory and riches!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "6x5" },
      { label: "Type Of Slot", value: "Pay anywhere" },
      { label: "Slot Features", value: "Double bet, free spin, bonus spins" },
      { label: "Volatility", value: "Very High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/jewel-of-wizard': {
    paragraphText: (
      <>
        Enter a magical realm in Jewels of the Wizards, a captivating 7x7 cluster slot where sparkling jewels and powerful wizardry combine for enchanting rewards. With a 96.62% RTP, high volatility, and a 29.03% win hit frequency, this slot offers a thrilling gameplay experience and the chance to win big with in-game Free Spins and Bonus Spins features. Uncover the mystical gems that lead to glittering wins as you explore the world of Magical Jewels, where every cluster brings you closer to magical riches and extraordinary prizes.      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "7x7" },
      // { label: "Type Of Slot", value: "Pay anywhere" },
      { label: "Slot Features", value: "In-Game free spins, bonus spins" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/cosmic-crazies': {
    paragraphText: (
      <>
        Blast off into the galaxy with Cosmic Crazies, an exciting 7x7 cluster slot that takes you on an interstellar adventure with quirky aliens and epic space wars. With a 96.62% RTP, high volatility, and a 29.03% win hit frequency, this game offers thrilling gameplay and the chance to win big through in-game Free Spins and Bonus Spins features. Journey through the Alien Space as you collect wild clusters of wins and unlock cosmic treasures in this out-of-this-world slot experience!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "7x7" },
      { label: "Type Of Slot", value: "Pay anywhere" },
      { label: "Slot Features", value: "In-Game free spins, bonus spins" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/jelly-bliss': {
    paragraphText: (
      <>
        Indulge in the sweet delights of Jelly Bliss, a colorful 7x7 cluster slot filled with bouncy jelly shapes and mouthwatering rewards. With a 96.62% RTP, high volatility, and a 29.03% win hit frequency, this vibrant game offers exciting gameplay with features like in-game Free Spins and Bonus Spins. Dive into a world of Sweet Treats where every cluster of jelly shapes brings you closer to delicious wins and sugary surprises!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "7x7" },
      // { label: "Type Of Slot", value: "Pay anywhere" },
      { label: "Slot Features", value: "In-Game free spins, bonus spins" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/drunkie-monkey': {
    paragraphText: (
      <>
        Join the wild party in Drunkie Monkey, a fun-filled 7x7 cluster slot where a cheeky monkey at the bar shakes up big wins with every spin! With a 96.62% RTP, high volatility, and a 29.03% win hit frequency, this playful slot offers exciting gameplay with in-game Free Spins and Bonus Spins features. Immerse yourself in Bar Humor as the mischievous monkey delivers laughs, wild spins, and the chance for boozy rewards in this lighthearted, high-energy slot!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "7x7" },
      // { label: "Type Of Slot", value: "Pay anywhere" },
      { label: "Slot Features", value: "In-Game free spins, bonus spins" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/cake-master': {
    paragraphText: (
      <>
        Whip up a deliciously sweet win in Cake Crafters, a vibrant 6x5 grid slots game that takes you into the world of colorful cakes and sugary delights. With a 96.56% RTP, high volatility, and a 16.51% win hit frequency, this game features exciting Free Spins and Bonus Buy options. Indulge in the Baking Fun, where every spin brings you closer to mouth-watering rewards and sweet surprises in this cake-filled adventure!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "7x5" },
      { label: "Slot Features", value: "Free spins, Bonus Buy" },
      { label: "Slot Type", value: "Ways win" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/wonderland-grove': {
    paragraphText: (
      <>
        Step into the mystical Wonderland Grove, a 6x5 grid slots game that takes you on a magical journey through an enchanting forest filled with whimsical rewards. With a 96.56% RTP, high volatility, and a 16.51% win hit frequency, this game features captivating Free Spins and Bonus Buy options. Explore the Fantasy Forest, where every spin unveils hidden treasures and magical surprises, making for an unforgettable adventure in the woods!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "7x5" },
      { label: "Slot Features", value: "Free spins, Bonus Buy" },
      { label: "Slot Type", value: "Ways win" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/sirens-beauty': {
    paragraphText: (
      <>
        Dig deep into a quarry of riches in Golden Quarry, a thrilling 6x3 grid slot game. With an RTP of 96% and high volatility, this game offers an exciting gold mining adventure. Use the Re-spin feature to increase your chances of uncovering golden treasures and sparkling wins. Bet from €0.20 to €240.00 as you explore the depths in search of precious rewards hidden beneath the surface! <br />
      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "3x3" },
      { label: "Bonus Game", value: "Yes" },
      { label: "Volatility", value: "Medium" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/amazon-sisters': {
    paragraphText: (
      <>
        Embark on an exciting adventure in Amazon Sisters, a 6x5 grid slots game that takes you deep into the jungle. With a 96.56% RTP, high volatility, and a 16.51% win hit frequency, this thrilling game features Free Spins and Bonus Buy options. Venture alongside the fierce Jungle Warriors, as the Amazonian sisters fiercely guard untold treasures. Every spin brings you closer to powerful rewards and hidden riches within the heart of the jungle!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "7x5" },
      { label: "Slot Features", value: "Free spins, Bonus Buy" },
      { label: "Slot Type", value: "Ways win" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/seek-and-catch': {
    paragraphText: (
      <>
        Embark on an exciting Treasure Hunt in Seek and Catch, a high-volatility slot with a 6x3 grid. With an RTP of 96%, this game offers a thrilling adventure as you hunt for hidden treasures. Re-spin feature adds an element of surprise, giving players more chances to uncover riches. Bet anywhere from €0.20 to €240.00 and join the quest, where unexpected twists and turns lead to potential big wins!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "6x3" },
      { label: "Slot Features", value: "Re-spin feature" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/feral-quest': {
    paragraphText: (
      <>
        Step into a world of Wild Adventure with Fereal Quest, a 6x3 grid slot that transports you on a fantastical journey through mythical lands in search of legendary fortunes. With an RTP of 96% and high volatility, this game offers thrilling gameplay and the opportunity to discover untold riches. The Re-spin feature adds an exciting twist, providing extra chances to win. Bet from €0.20 to €240.00 as you embark on this epic quest for legendary rewards!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "6x3" },
      { label: "Slot Features", value: "Re-spin feature" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/bandit-hunter': {
    paragraphText: (
      <>
        Saddle up and chase down bandits in the Wild West with Bandit Hunter, a thrilling 6x3 grid slot game. With an RTP of 96% and high volatility, this game immerses you in a daring adventure alongside a fearless sheriff in pursuit of outlaws and riches. Featuring the Re-spin feature, you get extra opportunities to catch the bandits and win big. Bet from €0.20 to €240.00 as you embark on this action-packed wild west journey!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "6x3" },
      { label: "Slot Features", value: "Re-spin feature" },
      { label: "Volatility", value: "High" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/golden-quarry': {
    paragraphText: (
      <>
        Dig deep into a quarry of riches in Golden Quarry, a thrilling 6x3 grid slot game. With an RTP of 96% and high volatility, this game offers an exciting gold mining adventure. Use the Re-spin feature to increase your chances of uncovering golden treasures and sparkling wins. Bet from €0.20 to €240.00 as you explore the depths in search of precious rewards hidden beneath the surface!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "6x3" },
      { label: "Slot Features", value: "Re-spin feature" },
      { label: "Volatility", value: "High" },


      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/tosuncuks-farm': {
    paragraphText: (
      <>
        Get ready for a quirky and fun-filled adventure with Tonsuk's Farm, a 5x5 grid slot game that takes inspiration from the infamous fraud tale of Tosuncuk and his blue egg mischief. With an RTP of 94.27% and medium volatility, this game offers exciting features such as Free Spins, Autoplay, Quickspin, and the Bonus Buy option. Explore the farm and uncover the mischievous antics of Tosuncuk for a chance at big wins and plenty of surprises!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "5x5" },
      { label: "Slot Features", value: "Free spin, Autoplay, Quickspin feature, Bonus buy" },
      { label: "Volatility", value: "Medium" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/dyno-dynasty': {
    paragraphText: (
      <>
        Step back in time to the Dinosaur Era and uncover prehistoric riches with Dyno Dynasty. This thrilling 5x5 grid slot game offers a glimpse into the ancient world of mighty dinosaurs, where treasures await. With an RTP of 94.27% and medium volatility, the game features exciting elements such as Free Spins, Autoplay, Quickspin, and Bonus Buy. Join the dinosaurs in their dynasty-themed adventure for a chance to discover legendary wins hidden in the prehistoric world!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "5x5" },
      { label: "Slot Features", value: "Free spin, Autoplay, Quickspin feature, Bonus buy" },
      { label: "Volatility", value: "Medium" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/shadow-of-sabbah': {
    paragraphText: (
      <>
        Venture into the Jungle Mystery in Shadow of Sabah, a captivating 5x5 grid slot game set in the mysterious jungles of Sabah. With an RTP of 94.27% and medium volatility, the game invites players to explore the shadows, where incredible treasures lie hidden. The slot features engaging elements like Free Spins, Autoplay, Quickspin, and Bonus Buy. Uncover the secrets of the jungle and discover riches that are just waiting to be found!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "5x5" },
      { label: "Slot Features", value: "Free spin, Autoplay, Quickspin feature, Bonus buy" },
      { label: "Volatility", value: "Medium" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  },
  '/solar-spins': {
    paragraphText: (
      <>
        Step into the Solar Energy of Solar Spins, a vibrant 5x5 grid slot game powered by the sun. With an RTP of 94.27% and medium volatility, this game offers players the chance to harness the sun's immense power, lighting up colossal wins. Featuring Free Spins, Autoplay, Quickspin, and Bonus Buy, Solar Spins invites you to spin under the radiant glow and experience thrilling gameplay with the potential for blazing rewards!      </>
    ),
    listItemTitle: "What to expect:",
    listText: [
      {
        listItem:
          "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
      },
      {
        listItem:
          "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
      },
      {
        listItem:
          "For every new mine created in free spins, a further two spins are awarded.",
      },
    ],
    gameDetailsList: [
      { label: "Release Date", value: "10/12/2024" },
      { label: "Bet Lines", value: "5x5" },
      { label: "Slot Features", value: "Free spin, Autoplay, Quickspin feature, Bonus buy" },
      { label: "Volatility", value: "Medium" },
      {
        label: "Languages", value:
          <div className="flag-box">
            <img src="/assets/stock-img/flag-england.webp" alt="Image" />

          </div>
      },
    ],
    headingText: "More Games",
    btnText: "Play",
    imgSrcGame: "/assets/stock-img/game_info_img.webp"
  }

}

